import { render, staticRenderFns } from "./passport.vue?vue&type=template&id=3776161c&scoped=true"
import script from "./passport.vue?vue&type=script&lang=js"
export * from "./passport.vue?vue&type=script&lang=js"
import style0 from "./passport.vue?vue&type=style&index=0&id=3776161c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3776161c",
  null
  
)

export default component.exports